import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, ShieldCheck } from 'lucide-react';
const stack = [{
  title: "Nano-Creative Bible 2.0",
  value: "$197",
  desc: "El protocolo completo. 10 capítulos de implementación pura, 60-70 páginas ejecutables. Sin teoría, sin relleno.",
  image: "https://cdn.magicpatterns.com/uploads/55KnTbRTivKPf69boyz6W6/labs-003.mp4",
  // Using video as main product representation
  isVideo: true
}, {
  title: "La Bóveda de Prompts de Oro",
  value: "$97",
  desc: "Los prompts exactos que generan anuncios premium. Listos para copiar, pegar y facturar.",
  image: "https://cdn.magicpatterns.com/uploads/rMdh97iSyvr22tFCGZvNWa/B-01.png"
}, {
  title: "Checklist Ad-Library Mastery",
  value: "$67",
  desc: "Espía y modela los anuncios que más facturan en tu nicho. El atajo de los profesionales.",
  image: "https://cdn.magicpatterns.com/uploads/uaksGprm7uMu5DGL4ueiFQ/B-02.png"
}, {
  title: "Plan de Implementación 7 Días",
  value: "$67",
  desc: "De cero a tu primer anuncio lanzado en una semana. Paso a paso, sin adivinar.",
  image: "https://cdn.magicpatterns.com/uploads/mZfipE1yWuddi1Tof7MVSN/B-03.png"
}, {
  title: "Grupo Privado Nano-Creative Elite",
  value: "$97",
  desc: "Feedback en vivo de tus anuncios, prompts actualizados y networking con creadores que escalan. Tu departamento de I+D en el bolsillo.",
  image: "https://cdn.magicpatterns.com/uploads/sGyUC6RGcNZxxxo6BT7pzJ/nano_B-4.png"
}];
export function ValueStack() {
  return <section id="pricing" className="py-12 md:py-24 bg-zinc-900 px-4 relative" data-id="element-202" data-mp="2m40pvfz5l7ka">
      <div className="max-w-5xl mx-auto" data-id="element-203" data-mp="2m1o8b3xb4z7r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-204" data-mp="2h4o2mu4ddyh6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-205" data-mp="mrpq03v76pqo">
            Un Arsenal Completo Valorado en $591 — Por El Precio de Un Café Con Postre
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6 md:gap-8" data-id="element-206" data-mp="2rrh67a4rmtdx">
          <div className="lg:col-span-3 space-y-4" data-id="element-207" data-mp="2vtu8fokb095y">
            {stack.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-4 p-4 rounded-2xl bg-zinc-950 border border-zinc-800 items-center" data-id="element-208" data-mp="2vw6x0kkkhhrz" data-mpi={index}>
                <div className="w-24 h-24 rounded-xl overflow-hidden shrink-0 bg-zinc-900 border border-zinc-800" data-id="element-209" data-mp="3fid32lo2wes1">
                  {item.isVideo ? <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-210" data-mp="3oj1hhhhdwh5g">
                      <source src={item.image} type="video/mp4" data-id="element-211" data-mp="3th2zdz32qafc" />
                    </video> : <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-212" data-mp="7h6pnvvclz8y" />}
                </div>
                <div data-id="element-213" data-mp="3tn3lehq5645y">
                  <div className="flex items-center justify-between mb-1" data-id="element-214" data-mp="3tmlkv8wg53s8">
                    <h3 className="text-white font-bold" data-id="element-215" data-mp="3pm1mk204zu4i">{item.title}</h3>
                    <span className="text-zinc-500 line-through text-sm" data-id="element-216" data-mp="3po4ljbj9oxld">{item.value}</span>
                  </div>
                  <p className="text-zinc-400 text-sm" data-id="element-217" data-mp="l7jv9rkrp1v4">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-2" data-id="element-218" data-mp="gfio2k2gi1by">
            <div className="sticky top-8 p-6 md:p-8 rounded-3xl bg-gradient-to-b from-amber-500/10 to-zinc-950 border border-amber-500/20" data-id="element-219" data-mp="18xxrzvearow1">
              <div className="text-center mb-8" data-id="element-220" data-mp="144l79wcqo28k">
                <p className="text-zinc-400 mb-2" data-id="element-221" data-mp="onmuku6bt923">Valor Total Real: <span className="line-through" data-id="element-222" data-mp="tnhkovia1um3">$591</span></p>
                <p className="text-sm font-bold text-amber-500 uppercase tracking-wider mb-4" data-id="element-223" data-mp="tp2egiwrp9iw">Precio de Lanzamiento Hoy</p>
                <div className="text-6xl font-bold text-white mb-2" data-id="element-224" data-mp="fpsxhh0qmbdv">$11.99</div>
                <p className="text-zinc-400 text-sm" data-id="element-225" data-mp="jplcabgq5dro">Pago único · Acceso de por vida</p>
              </div>

              <a href="https://pay.hotmart.com/R105772861J?checkoutMode=10" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'AddToCart');
              }
            }} className="w-full group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-amber-500 text-zinc-950 font-bold rounded-xl overflow-hidden transition-transform hover:scale-105 active:scale-95 mb-6" data-id="element-226" data-mp="17fny49u1pnhu">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform" data-id="element-227" data-mp="3fum5qefinq4q" />
                <span data-id="element-228" data-mp="3aureg9rtwyj5">QUIERO EL PROTOCOLO AHORA</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-229" data-mp="3atybzkzwkv6t" />
              </a>

              <div className="space-y-3" data-id="element-230" data-mp="3klvtf9hi8jdz">
                <div className="flex items-center gap-2 text-sm text-zinc-300 justify-center" data-id="element-231" data-mp="3kmx6tklzthyv">
                  <CheckCircle2 className="w-4 h-4 text-amber-500" data-id="element-232" data-mp="2wwt2fb0zde6t" />
                  <span data-id="element-233" data-mp="2rxgdmkqjtx1l">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-zinc-300 justify-center" data-id="element-234" data-mp="2rzb2ub8usbbh">
                  <CheckCircle2 className="w-4 h-4 text-amber-500" data-id="element-235" data-mp="36rupm1bp466r" />
                  <span data-id="element-236" data-mp="31tjfrqlehvoj">Sin suscripción</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-zinc-300 justify-center" data-id="element-237" data-mp="m3gnweqbv4hu">
                  <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-238" data-mp="h5exf8qko2wc" />
                  <span data-id="element-239" data-mp="h783altd2j3a">Garantía total de 7 días</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}